<template>
  <b-overlay :show="isAgencyConnecting || !currentAgency" rounded="sm">
    <div v-if="currentAgency && !isAgencyConnecting" class="admin-page d-flex flex-column">
      <div v-if="!hideBreadcrumb" class="admin-page--breadcrumb px-2 px-md-4 pt-2 pt-md-4">
        <AdminBreadcrumb :pageTitle="$route.name" />
      </div>
      <div class="admin-page--content">
        <router-view></router-view>
      </div>
    </div>
  </b-overlay>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import AdminBreadcrumb from "../components/AdminBreadcrumb.vue";

export default {
  name: "Admin",
  components: {
    AdminBreadcrumb,
  },
  computed: {
    ...mapGetters("agency", ["currentAgency", "isAgencyConnecting"]),
    ...mapGetters("user", ["isMobile"]),
    hideBreadcrumb() {
      const routeNames = ["Admin Dashboard"];
      return !this.$route.name || routeNames.includes(this.$route.name);
    }
  }
};
</script>

<style lang="scss">
.admin-page {
  width: 100%;
  height: 100%;

  &--content {
    flex: 1;
    overflow-y: auto;
  }
}
</style>
